package dev.terrakok.mapitan.ui.components

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.DpOffset
import androidx.compose.ui.unit.DpSize
import androidx.compose.ui.unit.dp

val SELECTION_FRAME_SIZE: DpSize = DpSize(40.dp, 50.dp)
val SELECTION_FRAME_OFFSET: DpOffset = DpOffset(0.dp, 10.dp)

class StrokeFramePainter(
    private val color: Color,
    private val strokeWidth: Dp = 1.5.dp,
) : Painter() {
    override val intrinsicSize: Size = Size.Unspecified

    override fun DrawScope.onDraw() {
        val stroke = strokeWidth.toPx()
        val inset = stroke / 2f
        drawRoundRect(
            color = color,
            topLeft = Offset(inset, inset),
            size = Size(size.width - stroke, size.height - stroke),
            style = Stroke(width = stroke),
        )
    }
}
